import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import template from "../../../../assets/templates/BovExo_template_vacinas.xlsx";
import { Creators as AppActions } from "../../../../store/ducks/app";
import { Row, Col, Icon, Upload, notification, Spin } from "antd";
import ButtonStandard from "../../../utils/button";
import {
  CustomModal,
  Container,
  Header,
  Title,
  ButtonWithoutBackground,
  DownloadButton,
  CustomSelect,
} from "./styles";
import { importAnimalVaccination } from "../../../../services/importService";

const AnimalVaccinationUploadModal = () => {
  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [identificationType, setIdentificationType] =
    useState("handlingNumber");

  const {
    translation,
    modalAnimalVaccinationUploadVisible,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const handleCancel = () => {
    setIsLoading(false);
    setFileList([]);
    dispatch(AppActions.hideModalAnimalVaccinationUpload());
  };

  const handleUpload = async () => {
    try {
      setIsLoading(true);
      await importAnimalVaccination({
        groupId,
        farmId,
        file: fileList[0],
        identificationType: identificationType,
      });
      notification.success({
        message: translation.importAnimalVaccination.successMessage,
        description: (
          <p>{translation.importAnimalVaccination.successDescription}</p>
        ),
      });
      handleCancel();
    } catch (error) {
      notification.error({
        message: translation.importAnimalVaccination.errorMessage,
        description: translation.importAnimalVaccination.errorDescription,
        duration: 0,
      });
      handleCancel();
    }
  };
  const props = {
    accept: ".xlsx",
    onRemove: (file) => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    showUploadList: false,
    fileList,
  };

  const { Dragger } = Upload;
  const { Option } = CustomSelect;

  return (
    <CustomModal
      width={535}
      visible={modalAnimalVaccinationUploadVisible}
      centered
      maskClosable={false}
      closable={false}
      footer={null}
    >
      <Container>
        <Spin spinning={isLoading}>
          <Header>
            <Title>{translation.importAnimalVaccination.title}</Title>
          </Header>
          <Row type="flex">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row type="flex" justify="start">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: translation.importAnimalVaccination.message,
                    }}
                  />
                </Col>
              </Row>
              <Row type="flex" justify="space-between" align="middle">
                <Col xs={12} sm={12} md={12} lg={12} xl={12} align="left">
                  <DownloadButton
                    href={template}
                    download="BovExo_template_vacinas.xlsx"
                  >
                    <Icon type="download" />
                    {translation.buttons.download}
                  </DownloadButton>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} align="left">
                  <Row type="flex" justify="space-between" align="middle">
                    <label className="formLabel">
                      {translation.importAnimalVaccination.identificationLabel}
                    </label>
                    <CustomSelect
                      name="identificationType"
                      value={identificationType}
                      onChange={(value) => setIdentificationType(value)}
                    >
                      <Option value="handlingNumber">
                        {translation.importAnimalVaccination.identification}
                      </Option>
                      <Option value="tagId">
                        {translation.importAnimalVaccination.electronicId}
                      </Option>
                      <Option value="sisbov">
                        {translation.importAnimalVaccination.sisbov}
                      </Option>
                    </CustomSelect>
                  </Row>
                </Col>
              </Row>
              <Row type="flex" className="uploadRow">
                <Row type="flex">
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Dragger {...props}>
                      {fileList.length > 0 ? (
                        <Fragment>
                          <p className="ant-upload-drag-icon">
                            <Icon type="file-excel" />
                          </p>
                          <p className="ant-upload-text">{fileList[0].name}</p>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <p className="ant-upload-drag-icon">
                            <Icon type="inbox" />
                          </p>
                          <p className="ant-upload-text">
                            {translation.importAnimalVaccination.draggerMessage}
                          </p>
                        </Fragment>
                      )}
                    </Dragger>
                  </Col>
                </Row>

                <Row
                  type="flex"
                  className="footer"
                  justify="space-between"
                  align="middle"
                >
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <ButtonStandard
                      type="button"
                      buttonType="type4"
                      size="s"
                      onClick={handleCancel}
                    >
                      {translation.buttons.cancel}
                    </ButtonStandard>
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16} align="right">
                    <ButtonWithoutBackground
                      type="submit"
                      onClick={handleUpload}
                      disabled={fileList.length === 0 ? true : false}
                    >
                      {translation.buttons.processVaccinations}
                    </ButtonWithoutBackground>
                  </Col>
                </Row>
              </Row>
            </Col>
          </Row>
        </Spin>
      </Container>
    </CustomModal>
  );
};

export default AnimalVaccinationUploadModal;
